<!-- Button that looks like a link, but has the shape/css/html of a button. -->
<!-- Added by us. This is not a component that's present in Tairo. -->
<script setup lang="ts">
const { icon } = defineProps<{
  icon?: string
}>()
</script>

<template>
  <NuxtLink
    class="text-primary-500 dark:text-primary-500 hover:text-primary-600 dark:hover:text-primary-600 h-10 gap-x-4 whitespace-nowrap px-4 pt-2 text-center font-semibold"
  >
    <slot />
    <Icon
      v-if="icon"
      :name="icon"
      size="sm"
      class="ml-3 h-5"
    />
  </NuxtLink>
</template>
